import { useState } from 'react';
import styles from './GiftModal.module.css';
import Modal from '../../../components/Modal/Modal.tsx';
import { ReactComponent as StarIcon } from '../../../assets/Inventory/stars.svg';
import { useTradeStore } from '../../../store/useTradeStore.ts';
import GiftSelectionList from '../GiftSelectionList/GiftSelectionList.tsx'; // Импортируем новый компонент

const GiftModal = () => {
  const [isSelectingGiveGift, setIsSelectingGiveGift] = useState(false);
  const [isSelectingTakeGift, setIsSelectingTakeGift] = useState(false); // New state for 'take' gift

  const { give, take } = useTradeStore();

  const handleGiveGiftSelectionClose = () => {
    setIsSelectingGiveGift(false);
  };

  const handleTakeGiftSelectionClose = () => { // New handler for 'take' gift
    setIsSelectingTakeGift(false);
  };

  let content;
  if (isSelectingGiveGift) {
    content = <GiftSelectionList onGiftSelect={handleGiveGiftSelectionClose} tradeType="give" />; // Pass tradeType
  } else if (isSelectingTakeGift) {
    content = <GiftSelectionList onGiftSelect={handleTakeGiftSelectionClose} tradeType="take" />; // Pass tradeType
  } else {
    content = (
      <div className={styles.wrapper}>
        <div>
          <div className={styles.iconWrapper}>
            <StarIcon className={styles.icon} />
          </div>
          <div className={styles.textContainer}>
            <h2>Слияние осколков</h2>
            <p>Выбери осколки для обмена</p>
          </div>
        </div>


        <div className={styles.tradeContainer}>
          {/* Блок "Отдаю". При клике открываем выбор подарка */}
          <div className={styles.tradeBlock} onClick={() => setIsSelectingGiveGift(true)}>
            {give.img ? (
              <div className={styles.tradeBlockContainer}>
                <img src={give.img} alt={give.name} className={styles.tradeImage} />
                <div className={styles.progressContainer}>
                  <div className={styles.inventoryProgressBar}>
                    <div className={styles.inventoryProgressBarFill}
                      style={{ width: `${give.progress / give.allProgress * 100}%` }}>
                    </div>
                    <span className={styles.progressText}>{give.progress}/{give.allProgress}</span>
                  </div>
                  <div className={styles.arrowRight}></div>
                  <div className={styles.progressContainer}>
                    <div className={styles.inventoryProgressBar}>
                      <div className={styles.inventoryProgressBarFill}
                        style={{ width: `${0 / give.allProgress * 100}%` }}>
                      </div>
                      <span className={styles.progressText}>0/{give.allProgress}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.name}>
                  {give.name} <span>(-{give.progress})</span>
                </div>
              </div>
            ) : (
              <div className={styles.tradeBlock__container}>
                <div className={styles.plus}></div>
                <div>
                  <div className={styles.tradeBlock__head}>Отдаю</div>
                  <div className={styles.tradeBlock__desc}>
                    Нажми,<br /> чтобы выбрать
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Блок "Получаю". При клике открываем выбор подарка */}
          <div className={styles.tradeBlock} onClick={() => setIsSelectingTakeGift(true)}> {/* Added onClick */}
            {take.img ? (
              <div className={styles.tradeBlockContainer}>
                <img src={take.img} alt={take.name} className={styles.tradeImage} />
                <div className={styles.progressContainer}>
                  <div className={styles.inventoryProgressBar}>
                    <div className={styles.inventoryProgressBarFill}
                      style={{ width: `${take.progress / take.allProgress * 100}%` }}>
                    </div>
                    <span className={styles.progressText}>{take.progress}/{take.allProgress}</span>
                  </div>
                  <div className={styles.arrowRight}></div>
                  <div className={styles.progressContainer}>
                    <div className={styles.inventoryProgressBar}>
                      <div className={styles.inventoryProgressBarFill}
                        style={{ width: `${take.progress + take.progress / take.allProgress * 100}%` }}>
                      </div>
                      <span className={styles.progressText}>{take.progress + take.progress}/{take.allProgress}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.namePlus}>
                  {take.name} <span>(+{take.progress})</span>
                </div>
              </div>
            ) : (
              <div className={styles.tradeBlock__container}>
                <div className={styles.plus}></div>
                <div>
                  <div className={styles.tradeBlock__head}>Получаю</div>
                  <div className={styles.tradeBlock__desc}>
                    Нажми,<br /> чтобы выбрать
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.btnContainer}>
          <button>Продолжить</button>
        </div>
      </div>
    );
  }

  return (
    <Modal noTopPadding={true}>
      <div className={styles.container}>
        {content}
      </div>
    </Modal>
  );
};

export default GiftModal;
